import type { ReactNode } from 'react';
import { APP_CONFIG } from '../../core/config';

interface AuthShellProps {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

/** Shared RTL card layout for every authentication screen. */
export function AuthShell({ icon, title, subtitle, children, footer }: AuthShellProps) {
  return (
    <main className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <section className="w-full max-w-sm bg-panel border border-line rounded-2xl shadow-sm p-6 sm:p-8">
        <header className="text-center mb-6">
          <div className="mx-auto mb-3 w-12 h-12 rounded-xl bg-brand-50 text-brand-500 flex items-center justify-center">
            {icon}
          </div>
          <h1 className="text-xl font-bold">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-ink/60">{subtitle}</p> : null}
        </header>

        {children}

        {footer ? <div className="mt-6 pt-4 border-t border-line">{footer}</div> : null}
      </section>
    </main>
  );
}

/** Small app signature shown under the auth card. */
export function AppSignature() {
  return (
    <p className="text-center text-[11px] text-ink/40" data-dir="ltr">
      {APP_CONFIG.appId} · v{APP_CONFIG.version}
    </p>
  );
}
